import { useQuery } from '@tanstack/react-query';
import { communicationClient } from 'clients/Communication/Communication';
import type { QuestionnaireConfigurationResponse } from 'clients/Communication/Questionnaire.dto';
import { QueryKey } from 'types/query';

const QUERY_KEY = [QueryKey.useQuestionnaireConfigurationQuery, { jobId: 0 }] as const;

export function getQuestionnaireConfigurationQueryKey(jobId: number) {
  return [QUERY_KEY[0], { jobId }] as const;
}

export async function questionnaireConfigurationQueryFn({
  queryKey,
}: {
  queryKey: readonly [string, { jobId: number }];
}): Promise<QuestionnaireConfigurationResponse> {
  const { data } = await communicationClient.ensureQuestionnaireConfiguration({ job_id: queryKey[1].jobId });
  return data;
}

export function useQuestionnaireConfigurationQuery(jobId: number | undefined, options?: { enabled?: boolean }) {
  const enabled = options?.enabled ?? Boolean(jobId);
  return useQuery({
    queryKey: getQuestionnaireConfigurationQueryKey(jobId ?? 0),
    enabled: Boolean(jobId) && enabled,
    queryFn: questionnaireConfigurationQueryFn,
  });
}
